import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { billsQueryOptions } from '@/features/bills/api'
import { BillsScreen } from '@/features/bills/bills-screen'
import { type BillsSearch, billsSearchSchema, toBillListParams } from '@/features/bills/search'

/**
 * Layout PATHLESS de Recebimentos › Receber — espelho de Pagamentos › Pagar,
 * com `direction='receivable'`. Mesma tela composta (`/v1/bills`), mesmo padrão
 * de filtros na URL.
 */
export const Route = createFileRoute('/_authed/recebimentos/_receber')({
  validateSearch: billsSearchSchema,
  loaderDeps: ({ search }) => ({ params: toBillListParams(search, 'receivable') }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(billsQueryOptions(deps.params)),
  component: ReceberLayout,
})

function ReceberLayout() {
  const { t } = useTranslation(['nav'])
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <BillsScreen
        direction="receivable"
        title={t('nav:receivables.receive')}
        novoTo="/recebimentos/agendar"
        novoLabel={t('nav:receivables.newSchedule')}
        search={search}
        onSearchChange={(patch) => {
          // `to` EXPLÍCITO para a folha: sem ele, `navigate` a partir deste
          // layout PATHLESS resolve o destino como o próprio layout (não a rota
          // `receber` que casa na URL), e a navegação vira no-op — filtro,
          // paginação e "linhas" não disparavam request nenhum.
          //
          // `prev` ANOTADO: o `to` conserta o runtime, mas não basta para o tipo
          // aqui — sem a anotação o updater cai em `any` (TS7006).
          void navigate({
            to: '/recebimentos/receber',
            search: (prev: BillsSearch) => ({ ...prev, ...patch }),
            replace: true,
          })
        }}
      />
      <Outlet />
    </>
  )
}
